import footerLogo from './footerLogo.png';
import headerLogo from './headerLogo.png';
import headerLogoFull from './headerLogoFull.png';
import headerLogoBlack from './headerLogo-Black.png';

export {
    footerLogo,
    headerLogo,headerLogoBlack,
    headerLogoFull
}